import type { LucideIcon } from 'lucide-react'
import { icons as lucideIcons, Tag } from 'lucide-react'

interface PoiIconProps {
  name: string | null | undefined
  size?: number
  className?: string
}

export function PoiIcon({ name, size = 16, className }: PoiIconProps) {
  if (!name) return null
  const Icon = (lucideIcons[name as keyof typeof lucideIcons] as LucideIcon) ?? Tag
  return <Icon size={size} className={className} aria-hidden="true" />
}

export function isKnownIcon(name: string): boolean {
  return name in lucideIcons
}
